import {useEffect, useState, useMemo} from 'react'
import {useV1PeripheryContract} from './useContract'
import {useBlockNumber} from '../state/application/hooks'
import {useActiveWeb3React} from './web3'
import {BigNumber} from 'ethers'

/**
 * Returns cap oi for input market address
 * @param marketAddress address of market to query cap oi
 */
export function useMarketCapOi(marketAddress?: string): BigNumber | undefined {
  const peripheryContract = useV1PeripheryContract()
  const blockNumber = useBlockNumber()
  const {account} = useActiveWeb3React()
  const [capOi, setCapOi] = useState()

  useEffect(() => {
    if (!peripheryContract || !marketAddress || !blockNumber) return
    ;(async () => {
      try {
        setCapOi(await peripheryContract.capOi(marketAddress))
      } catch (error) {
        console.log('market inside useMarketCapOi: ', marketAddress)
      }
    })()
  }, [peripheryContract, marketAddress, blockNumber, account])

  return useMemo(() => {
    return capOi
  }, [capOi])
}
